import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../context";
import { RequireAuth } from '../../components/auth/RequireAuth';

export default function GetSeriesContent(
  pathname: string,
  Series:any,
  Results:any,
  Calendar:any,
  Rules:any,
  DriversAndTeams:any,
  Stats:any,
  Gallery:any,
  Register:any,
  Qualifying: any,
){
  const { 
    theme, setTheme, 
    density, setDensity,
    seriesContent, setSeriesContent,
  } = useContext(GlobalContext);

  switch (pathname) {
    case "series": {
      return <Series />;
      break;
    }
    case "results": {
      return <Results />;
      break;
    }
    case "calendar": {
      return <Calendar />;
      break;
    }
    case "rules": {
      return <Rules />;
      break;
    }
    case "drivers_teams": {
      return <DriversAndTeams />;
      break;
    }
    case "stats": {
      return <Stats />;
      break;
    }
    case "gallery": {
      return <Gallery />;
      break;
    }
    case "register": {
      return <Register />;
      break;
    }
    case "qualifying": {
      return (
        <RequireAuth>
          <Qualifying />
        </RequireAuth>
      )
      break;
    }
  }

  return <Series />;
}